import {ChangeDetectorRef, Component, ElementRef, HostListener, Injector, Input, OnChanges} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {CountEditService} from '../services/count-edit.service';

/**
 * Инлайновое редактирование количества единиц оборудования
 */

@Component({
    selector: 'app-count-edit',
    templateUrl: 'count-edit.component.html'
})

export class CountEditComponent extends FrontendFormComponent implements OnChanges {
    @Input() cardId: string|number;
    @Input() count: string;
    @Input() measureUnit: string;

    public isEditMode = false;

    form = this._fb.group({
       id: [],
       count: [],
    });

    constructor(
        injector: Injector,
        private el: ElementRef,
        private cd: ChangeDetectorRef,
        public formService: CountEditService,
    ) {
        super(injector);
    }

    init() {

    }

    @HostListener('document:keydown.esc')
    private onEscPress() {
        this.endEdit();
    }

    ngOnChanges() {
        this.resetForm();
    }

    public onSubmit() {
        this.save(this.form);
    }

    public startEdit() {
        this.isEditMode = true;
        this.focusInput();
        this.cd.detectChanges();
    }

    public endEdit() {
        this.isEditMode = false;
        this.resetForm();
        this.isPending = false;
        this.cd.detectChanges();
    }

    public afterSave() {
        this.count = this.form.get('count').value;
        this.endEdit();
    }

    /**
     * Переопределяем метод, чтобы сохранять по Enter
     * @returns {boolean}
     */
    public onEnterPress() {
        return true;
    }

    private resetForm() {
        this.form.patchValue({
            id: this.cardId,
            count: this.count
        });
    }

    /**
     * Фокусируемся на Input внутри формы
     * @TODO Придумать, как без этого лютого костыля и копания в DOM руками сфокусироваться на элементе
     */
    private focusInput() {
        // Обновляем view, чтобы input уже был отрисован
        this.cd.detectChanges();
        const native: HTMLElement = this.el.nativeElement;
        const input = native.querySelector('input');

        if (input) {
            input.focus();
        }
    }
}
